// extracted by mini-css-extract-plugin
export default {"clearRectangle":"SkeletSportItem_clearRectangle--Nuu","skelet":"SkeletSportItem_skelet--cbz","skeletShimmer":"SkeletSportItem_skeletShimmer--m0d"};